<div class="main-content">
	<div class="container-fluid">
		<div class="card">
			<div class="card-header card-header-{{ color}}-5">
				<h4 class="card-title">Education Voucher Report</h4>
				<p class="card-category"></p>
			</div>
			<div class="card-body">
				<form [formGroup]="searchForm" class="m-0 p-0">
			<div class="row m-0 p-0">
				<div class="col-xs-12 col-md-4 col-4">
				<mat-form-field color="accent" class="datepicker" appearance="outline">
                <mat-label>Enter a date range</mat-label>
                <div class="daterange-div">
                    <mat-date-range-input [rangePicker]="picker" class="daterange-input">
                        <input matStartDate placeholder="Start date" formControlName="startdate">
                        <input matEndDate placeholder="End date" formControlName="enddate">
                    </mat-date-range-input>
                    <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-date-range-picker #picker></mat-date-range-picker>
                </div>
				</mat-form-field>
				</div>
				<div class="col-xs-12 col-md-4 col-4">
					<mat-form-field appearance="outline">
						<mat-label>Reward Type</mat-label>
						<mat-select formControlName="voucher" multiple appSelectAll>
							<mat-option *ngFor="let v of programs" [value]="v.id">
								{{v.name}}
							</mat-option>
						</mat-select>
					</mat-form-field>
				</div>
				<div class="col-md-4 mt-4">
					<span *ngIf="sending">
						<svg class="spinner" width="35px" height="35px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
							<circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
						</svg>
					</span>
					<button mat-raised-button class="btn-success btn-height" (click)="$event.preventDefault();exportXls()" *ngIf="reportResults.length != 0">
						<i class="fa fa-file-excel-o"></i> XLS
					</button>
					&nbsp;
					<button mat-raised-button class="btn-danger btn-height" (click)="$event.preventDefault();exportPdf()" *ngIf="reportResults.length != 0">
						<i class="fa fa-file-pdf-o"></i> PDF
					</button>
					&nbsp;
					<button mat-raised-button color="accent" class="mt-2" (click)="vouchers()" *ngIf="!sending">
						<mat-icon>refresh</mat-icon>
					</button>
				</div>
			</div>
			</form>
			</div>


	<div #print_table>
		<table class="table table-striped table-bordered table-hover table-fixed" *ngIf="!loading">
			<thead>
				<tr>
					<th (click)="sortBy('name')">Voucher Type</th>
					<th (click)="sortBy('voucher_number')">Voucher #</th>
					<th (click)="sortBy('amount')">Dollar Amount</th>
					<th (click)="sortBy('brname')">Customer Name</th>
				</tr>
			</thead>
			<tbody>
				<tr *ngFor="let r of sortedReportResults">
					<td>{{ r.name }}</td>
					<td>{{ r.voucher_number }}</td>
					<td>{{ r.amount | currency}}</td>
					<td>{{ r.brname }}</td>
				</tr>
			</tbody>
		</table>
	</div>
	</div>
	</div>
	</div>